/* FAQ Search — section-faq-search.js. Vanilla JS, inga externa beroenden.
   Sök (fråga+svar), highlight, accordion (en öppen), expandera/stäng alla,
   träffräknare, URL-anchor + autoscroll. Stödjer flera instanser + Theme Editor. */
(function () {
  'use strict';
  var DEBOUNCE_MS = 120;

  function normalize(str) { return (str || '').toString().toLowerCase().trim(); }
  function escapeRegExp(str) { return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function escapeHtml(str) { return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function debounce(fn, wait) { var t; return function () { var c = this, a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); }; }

  function FaqSearch(root) {
    this.root = root;
    this.input = root.querySelector('[data-faq-input]');
    this.clearBtn = root.querySelector('[data-faq-clear]');
    this.countEl = root.querySelector('[data-faq-count]');
    this.emptyEl = root.querySelector('[data-faq-empty]');
    this.expandAllBtn = root.querySelector('[data-faq-expand-all]');
    this.collapseAllBtn = root.querySelector('[data-faq-collapse-all]');
    this.categories = Array.prototype.slice.call(root.querySelectorAll('[data-faq-category]'));
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    this.items.forEach(function (item) {
      var qEl = item.querySelector('[data-faq-question-text]');
      var aEl = item.querySelector('[data-faq-answer-text]');
      item._faq = {
        questionText: item.getAttribute('data-faq-question') || '',
        answerText: item.getAttribute('data-faq-answer') || '',
        questionEl: qEl, answerEl: aEl,
        questionHtml: qEl ? qEl.innerHTML : '',
        answerHtml: aEl ? aEl.innerHTML : ''
      };
    });
    this.bind();
    this.handleDeepLink();
  }

  FaqSearch.prototype.bind = function () {
    var self = this;
    if (this.input) { this.input.addEventListener('input', debounce(function () { self.filter(self.input.value); }, DEBOUNCE_MS)); }
    if (this.clearBtn) { this.clearBtn.addEventListener('click', function () { self.input.value = ''; self.filter(''); self.input.focus(); }); }
    this.root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-faq-trigger]');
      if (!trigger || !self.root.contains(trigger)) return;
      var item = trigger.closest('[data-faq-item]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) { self.close(item); } else { self.closeAll(); self.open(item); }
    });
    if (this.expandAllBtn) { this.expandAllBtn.addEventListener('click', function () { self.items.forEach(function (item) { if (!item.hidden) self.open(item); }); }); }
    if (this.collapseAllBtn) { this.collapseAllBtn.addEventListener('click', function () { self.closeAll(); }); }
  };

  FaqSearch.prototype.open = function (item) {
    if (!item) return;
    item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'true');
    item.querySelector('[data-faq-panel]').setAttribute('data-open', '');
  };
  FaqSearch.prototype.close = function (item) {
    if (!item) return;
    item.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false');
    item.querySelector('[data-faq-panel]').removeAttribute('data-open');
  };
  FaqSearch.prototype.closeAll = function () { var s = this; this.items.forEach(function (i) { s.close(i); }); };

  FaqSearch.prototype.filter = function (rawQuery) {
    var query = normalize(rawQuery);
    var hasQuery = query.length > 0;
    var matches = 0;
    var self = this;
    if (this.clearBtn) this.clearBtn.hidden = !hasQuery;
    this.items.forEach(function (item) {
      var data = item._faq;
      var inQ = normalize(data.questionText).indexOf(query) !== -1;
      var inA = normalize(data.answerText).indexOf(query) !== -1;
      var isMatch = !hasQuery || inQ || inA;
      item.hidden = !isMatch;
      if (isMatch && hasQuery) { matches++; self.highlight(item, rawQuery.trim()); self.open(item); }
      else { self.resetHighlight(item); if (hasQuery) self.close(item); }
      if (!hasQuery) self.close(item);
    });
    this.categories.forEach(function (cat) {
      var visible = cat.querySelectorAll('[data-faq-item]:not([hidden])').length;
      cat.hidden = hasQuery && visible === 0;
    });
    if (hasQuery) {
      this.countEl.hidden = false;
      var one = this.countEl.getAttribute('data-one') || '1 träff';
      var many = this.countEl.getAttribute('data-many') || 'träffar';
      this.countEl.textContent = matches === 1 ? one : matches + ' ' + many;
      this.emptyEl.hidden = matches !== 0;
    } else {
      this.countEl.hidden = true; this.countEl.textContent = ''; this.emptyEl.hidden = true;
    }
  };

  FaqSearch.prototype.highlight = function (item, term) {
    if (!term) { this.resetHighlight(item); return; }
    var re = new RegExp('(' + escapeRegExp(term) + ')', 'gi');
    var data = item._faq;
    if (data.questionEl) { data.questionEl.innerHTML = escapeHtml(data.questionText).replace(re, '<mark class="faq-search__mark">$1</mark>'); }
    if (data.answerEl) { data.answerEl.innerHTML = escapeHtml(data.answerText).replace(re, '<mark class="faq-search__mark">$1</mark>'); }
  };
  FaqSearch.prototype.resetHighlight = function (item) {
    var data = item._faq;
    if (data.questionEl) data.questionEl.innerHTML = data.questionHtml;
    if (data.answerEl) data.answerEl.innerHTML = data.answerHtml;
  };

  FaqSearch.prototype.handleDeepLink = function () {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var target;
    try { target = this.root.querySelector(hash + '[data-faq-item]'); } catch (e) { return; }
    if (!target) return;
    this.open(target);
    window.requestAnimationFrame(function () { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-faq-search]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root._faqInit) return;
      root._faqInit = true;
      new FaqSearch(root);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
